module.exports = __webpack_public_path__ + "static/img/loginLogo.bfe23b17.png";